import isNumber from 'is-number';
import { imgType } from '../../markdown/Image';
import { ImgSizeAttr } from './const';
export const addImage = (schema) => {
    return {
        isEnable: (state) => state.selection.empty,
        run(state, dispatch, _view, attrs) {
            const params = attrs;
            if (params === null || params === void 0 ? void 0 : params.src) {
                const { src, title, alt, width, height } = params;
                const imgAttrs = {
                    [ImgSizeAttr.Src]: src,
                    [ImgSizeAttr.Title]: title !== null && title !== void 0 ? title : '',
                    [ImgSizeAttr.Alt]: alt !== null && alt !== void 0 ? alt : '',
                };
                if (isNumber(width)) {
                    imgAttrs[ImgSizeAttr.Width] = String(width);
                }
                if (isNumber(height)) {
                    imgAttrs[ImgSizeAttr.Height] = String(height);
                }
                dispatch(state.tr.insert(state.selection.from, imgType(schema).create(imgAttrs)));
            }
        },
    };
};
